import type { HasViewId } from '@ardoq/graph';
import { actionCreator } from '@ardoq/rxbeach';
import { ViewContext, ViewSettingsControlsDependencies } from './types';

export const updateViewContext = actionCreator<ViewContext>(
  '[VIEW_PANE_HEADER] UPDATE_VIEW_CONTEXT'
);
type UpdateViewPropertiesArgs = HasViewId & {
  viewProperties: Record<string, any>;
};
export const updateViewProperties = actionCreator<UpdateViewPropertiesArgs>(
  '[VIEW_PANE_HEADER] UPDATE_VIEW_PROPERTIES'
);

export type UpdateSettingsBarDataArgs<T> = HasViewId & {
  settingsControlsDependencies: ViewSettingsControlsDependencies<T>;
};
export const updateSettingsBarData = actionCreator<
  UpdateSettingsBarDataArgs<Record<string, any>>
>('[VIEW_PANE_SETTINGS_BAR] UPDATE_SETTINGS_BAR_DATA');
